export interface IProfession {
  readonly code: string;
  readonly name: string;
}

export enum ProfessionTypeEnum {
  DA = 'DA',
  DN = 'DN',
  RDH = 'RDH',
  FD = 'FD',
}
